<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.hotel') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-wrapper">
      <ul class="news-list">
        <li v-for="item in hotelList" :key="item.id">
          <img :src="item.image" />
          <div class="text">
            <h3>{{ item.merchant_name }}</h3>
            <div>
              <p>{{ getTitle('hotel.tel') }}：{{ item.tel }}</p>
              <p>{{ getTitle('hotel.address') }}：{{ item.address }}</p>
              <p>{{ item.distance }}</p>
            </div>
          </div>
          <div class="button" v-if="!item.buttonHidden">
            <a class="btn" @click="goAppointment(item)">{{
              getTitle('hotel.booking')
            }}</a>
          </div>
        </li>
      </ul>
      <el-pagination
        v-if="hotelList && hotelList.length > 0"
        background
        layout="prev, pager, next"
        :page-count="pageAll"
        :current-page="current_page"
        @current-change="currentChange"
      >
      </el-pagination>
      <div class="list-none" v-if="hotelList.length == 0">
        <p>{{ getTitle('content.noData') }}</p>
      </div>
    </div>
    <el-dialog
      :title="getTitle('hotel.tips')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <p class="text-center">{{ getTitle('hotel.call') }}{{ phoneNum }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          getTitle('hotel.cancel')
        }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{
          getTitle('hotel.ok')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
export default {
  components: {},
  data() {
    return {
      hotelList: [],
      dialogVisible: false,
      phoneNum: '',
      buttonHidden: false,
      page: 1,
      pageAll: 0,
      current_page: 1,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to, from);
      if (to.fullPath !== from.fullPath) {
        this.page = 1;
        this.getHotelList(this.locale);
      }
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getHotelList(this.locale);
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getHotelList(languageStr) {
      const getHotelList = await www.getStayList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        language: languageStr == 'zh-cmn-Hans' ? 'zh' : languageStr,
        page: this.page,
        page_size: 10,
      });
      let tempHotelList = getHotelList.data;
      tempHotelList.forEach((item) => {
        if (!item.website_link && !item.tel) {
          this.$set(item, 'buttonHidden', true);
        } else {
          this.$set(item, 'buttonHidden', false);
        }
      });
      this.hotelList = tempHotelList;
      this.pageAll = getHotelList.page_total; // Math.ceil(orderNumberTotal / 2);
      this.current_page = getHotelList.current_page;
    },
    currentChange(value) {
      this.page = value;
      this.getHotelList(this.locale);
    },
    goAppointment(item) {
      this.phoneNum = item.tel;
      if (item.website_link && item.website_link.length != 0) {
        window.open(item.website_link);
      } else {
        this.dialogVisible = true;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.news-wrapper {
  width: 1100px;
  margin: 20px auto;
  .news-list {
    text-align: left;
    list-style: none;
    li {
      display: flex;
      margin-bottom: 20px;
      padding: 30px 30px;
      border-radius: 10px;
      background: #fff;
      img {
        width: 200px;
        height: 140px;
        margin-right: 30px;
        border-radius: 10px;
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 680px;
        line-height: 28px;
        h3 {
          color: #191b26;
          font-weight: normal;
          font-size: 24px;
          line-height: 32px;
        }
        p {
          color: #515457;
        }
      }
      .button {
        flex: 1;
        .btn {
          display: block;
          padding: 9px 0;
          border: 1px solid #31a775;
          color: #31a775;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    li:hover {
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
    }
  }
  .el-pagination {
    padding: 40px 0 60px;
    text-align: center;
  }
  .list-none {
    padding: 40px 0;
    text-align: center;
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
</style>
